module.exports = __webpack_public_path__ + "_assets/img/profile-09.97cd5661.svg";